<mf-grid
  #grid
  [actionButtons]="gridActionButtons"
  [apiEndpoint]="apiEndpoint"
  [columns]="columns"
  [initialFilters]="filters"
  [menuItems]="menuItems" />
